import React, { useState } from 'react';

function AddObjectiveButton({ setUiMode }) {
  const [hovered, setHovered] = useState(false);

  const baseStyle = {
    position: 'fixed',
    top: '180px',
    right: '25px',
    zIndex: 1000,
  };

  const buttonStyle = {
    borderRadius: hovered ? '14px' : '50%',
    border: 'none',
    width: hovered ? '150px' : '50px',
    height: '50px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1c9420',
    color: '#fff',
    cursor: 'pointer',
    boxShadow: '0 8px 16px rgba(122, 118, 118, 1)',
    transition: 'width 0.3s ease, border-radius 0.3s ease, padding 0.3s ease',
    overflow: 'hidden',
    padding: hovered ? '0 15px' : '0',
  };

  return (
    <div style={baseStyle}>
      <button
        onClick={() => setUiMode('add')}
        style={buttonStyle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Add Objective"
        title="Add Objective"
      >
        {hovered ? '+ Add Objective' : '+'}
      </button>
    </div>
  );
}

export default AddObjectiveButton;
